import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  AWSDate: { input: any; output: any };
  AWSDateTime: { input: any; output: any };
  AWSEmail: { input: any; output: any };
  AWSPhone: { input: any; output: any };
  AWSTimestamp: { input: any; output: any };
  AWSURL: { input: any; output: any };
};

export type AddressInput = {
  city: Scalars["String"]["input"];
  countryCode?: InputMaybe<Scalars["String"]["input"]>;
  county?: InputMaybe<Scalars["String"]["input"]>;
  lotUnit?: InputMaybe<Scalars["String"]["input"]>;
  stateCode: Scalars["String"]["input"];
  streetAddress: Scalars["String"]["input"];
  zipCode: Scalars["String"]["input"];
};

export type Claim = {
  claimLocator: Scalars["ID"]["output"];
};

export type ClaimFilesInput = {
  claimLocator: Scalars["ID"]["input"];
  fileNames: Array<Scalars["String"]["input"]>;
};

export type CreateClaimInput = {
  claimNumber?: InputMaybe<Scalars["String"]["input"]>;
  damageDescription: Scalars["String"]["input"];
  damageRepaired?: InputMaybe<Scalars["Boolean"]["input"]>;
  dateOfLoss: Scalars["AWSDate"]["input"];
  emergencyServiceContacts?: InputMaybe<Array<EmergencyServiceContactInput>>;
  fireDepartmentContacted?: InputMaybe<Scalars["Boolean"]["input"]>;
  injuredParties?: InputMaybe<Array<InjuredPartyInput>>;
  liabilityClaimReason?: InputMaybe<LiabilityClaimReason>;
  lossAddress: Scalars["String"]["input"];
  lossType: LossType;
  policyLocator?: InputMaybe<Scalars["ID"]["input"]>;
  propertyAddress?: InputMaybe<AddressInput>;
  reportingParty: ReportingPartyInput;
  sourceOfDamageWater?: InputMaybe<SourceOfDamageWater>;
  sourceOfDamageWeather?: InputMaybe<SourceOfDamageWeather>;
  theftOrVandalismClaimType?: InputMaybe<TheftOrVandalism>;
};

export type EmergencyServiceContactInput = {
  contactType: EmergencyServiceContactType;
  departmentName: Scalars["String"]["input"];
};

export enum EmergencyServiceContactType {
  FireDepartment = "FireDepartment",
  PoliceDepartment = "PoliceDepartment",
}

export type FileUploadUrl = {
  fileName: Scalars["String"]["output"];
  uploadUrl: Scalars["String"]["output"];
};

export type FindPolicyForClaimInput = {
  policyLocator?: InputMaybe<Scalars["String"]["input"]>;
  propertyAddress?: InputMaybe<AddressInput>;
};

export type InjuredPartyInput = {
  address: AddressInput;
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  phoneNumber?: InputMaybe<Scalars["AWSPhone"]["input"]>;
};

export enum LiabilityClaimReason {
  Lawsuit = "Lawsuit",
  MedicalPayments = "MedicalPayments",
  Other = "Other",
}

export enum LossType {
  FireOrSmokeDamage = "FireOrSmokeDamage",
  Liability = "Liability",
  Other = "Other",
  TheftOrVandalism = "TheftOrVandalism",
  WaterDamage = "WaterDamage",
  WeatherOrPropertyDamage = "WeatherOrPropertyDamage",
}

export type Mutation = {
  createClaim: Claim;
};

export type MutationCreateClaimArgs = {
  createClaimInput: CreateClaimInput;
};

export type PreciselyAddress = {
  addressLastLine: Scalars["String"]["output"];
  addressNumber?: Maybe<Scalars["String"]["output"]>;
  city: Scalars["String"]["output"];
  country: Scalars["String"]["output"];
  formattedAddress: Scalars["String"]["output"];
  mainAddressLine: Scalars["String"]["output"];
  postCode: Scalars["String"]["output"];
  state: Scalars["String"]["output"];
  streetName: Scalars["String"]["output"];
};

export type PreciselyLocation = {
  address: PreciselyAddress;
  units: Array<Units>;
};

export type Query = {
  findPolicyForClaim: Scalars["Boolean"]["output"];
  getAutocompleteAddresses: Array<PreciselyLocation>;
  getClaimUploadUrls: Array<FileUploadUrl>;
};

export type QueryFindPolicyForClaimArgs = {
  input: FindPolicyForClaimInput;
};

export type QueryGetAutocompleteAddressesArgs = {
  searchText: Scalars["String"]["input"];
};

export type QueryGetClaimUploadUrlsArgs = {
  claimFiles: ClaimFilesInput;
};

export enum RelationshipToInsured {
  Child = "Child",
  FamilyMember = "FamilyMember",
  Other = "Other",
  Policyholder = "Policyholder",
  SecondOwner = "SecondOwner",
  Spouse = "Spouse",
}

export type ReportingPartyInput = {
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  phoneNumber: Scalars["AWSPhone"]["input"];
  relationshipToInsured: RelationshipToInsured;
};

export enum SourceOfDamageWater {
  Appliance = "Appliance",
  FreezingPipes = "FreezingPipes",
  Other = "Other",
  Plumbing = "Plumbing",
  Roof = "Roof",
  SumpPumpOrSewerBackup = "SumpPumpOrSewerBackup",
}

export enum SourceOfDamageWeather {
  Flood = "Flood",
  Hail = "Hail",
  Lightning = "Lightning",
  Other = "Other",
  WeightFromSnowOrIce = "WeightFromSnowOrIce",
  Wind = "Wind",
}

export enum TheftOrVandalism {
  Theft = "Theft",
  Vandalism = "Vandalism",
}

export type Units = {
  formattedUnitAddress: Scalars["String"]["output"];
  lotUnit?: Maybe<Scalars["String"]["output"]>;
};

export type CreateClaimMutationVariables = Exact<{
  createClaimInput: CreateClaimInput;
}>;

export type CreateClaimMutation = { createClaim: { claimLocator: string } };

export type FindPolicyForClaimQueryVariables = Exact<{
  input: FindPolicyForClaimInput;
}>;

export type FindPolicyForClaimQuery = { findPolicyForClaim: boolean };

export type GetClaimUploadUrlsQueryVariables = Exact<{
  claimFiles: ClaimFilesInput;
}>;

export type GetClaimUploadUrlsQuery = {
  getClaimUploadUrls: Array<{ fileName: string; uploadUrl: string }>;
};

export const CreateClaimDocument = gql`
  mutation CreateClaim($createClaimInput: CreateClaimInput!) {
    createClaim(createClaimInput: $createClaimInput) {
      claimLocator
    }
  }
`;
export type CreateClaimMutationFn = Apollo.MutationFunction<
  CreateClaimMutation,
  CreateClaimMutationVariables
>;

/**
 * __useCreateClaimMutation__
 *
 * To run a mutation, you first call `useCreateClaimMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClaimMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClaimMutation, { data, loading, error }] = useCreateClaimMutation({
 *   variables: {
 *      createClaimInput: // value for 'createClaimInput'
 *   },
 * });
 */
export function useCreateClaimMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateClaimMutation,
    CreateClaimMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateClaimMutation, CreateClaimMutationVariables>(
    CreateClaimDocument,
    options
  );
}
export type CreateClaimMutationHookResult = ReturnType<
  typeof useCreateClaimMutation
>;
export type CreateClaimMutationResult =
  Apollo.MutationResult<CreateClaimMutation>;
export type CreateClaimMutationOptions = Apollo.BaseMutationOptions<
  CreateClaimMutation,
  CreateClaimMutationVariables
>;
export const FindPolicyForClaimDocument = gql`
  query FindPolicyForClaim($input: FindPolicyForClaimInput!) {
    findPolicyForClaim(input: $input)
  }
`;

/**
 * __useFindPolicyForClaimQuery__
 *
 * To run a query within a React component, call `useFindPolicyForClaimQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindPolicyForClaimQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindPolicyForClaimQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindPolicyForClaimQuery(
  baseOptions: Apollo.QueryHookOptions<
    FindPolicyForClaimQuery,
    FindPolicyForClaimQueryVariables
  > &
    (
      | { variables: FindPolicyForClaimQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FindPolicyForClaimQuery,
    FindPolicyForClaimQueryVariables
  >(FindPolicyForClaimDocument, options);
}
export function useFindPolicyForClaimLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FindPolicyForClaimQuery,
    FindPolicyForClaimQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FindPolicyForClaimQuery,
    FindPolicyForClaimQueryVariables
  >(FindPolicyForClaimDocument, options);
}
export function useFindPolicyForClaimSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FindPolicyForClaimQuery,
    FindPolicyForClaimQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FindPolicyForClaimQuery,
    FindPolicyForClaimQueryVariables
  >(FindPolicyForClaimDocument, options);
}
export type FindPolicyForClaimQueryHookResult = ReturnType<
  typeof useFindPolicyForClaimQuery
>;
export type FindPolicyForClaimLazyQueryHookResult = ReturnType<
  typeof useFindPolicyForClaimLazyQuery
>;
export type FindPolicyForClaimSuspenseQueryHookResult = ReturnType<
  typeof useFindPolicyForClaimSuspenseQuery
>;
export type FindPolicyForClaimQueryResult = Apollo.QueryResult<
  FindPolicyForClaimQuery,
  FindPolicyForClaimQueryVariables
>;
export const GetClaimUploadUrlsDocument = gql`
  query GetClaimUploadUrls($claimFiles: ClaimFilesInput!) {
    getClaimUploadUrls(claimFiles: $claimFiles) {
      fileName
      uploadUrl
    }
  }
`;

/**
 * __useGetClaimUploadUrlsQuery__
 *
 * To run a query within a React component, call `useGetClaimUploadUrlsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClaimUploadUrlsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClaimUploadUrlsQuery({
 *   variables: {
 *      claimFiles: // value for 'claimFiles'
 *   },
 * });
 */
export function useGetClaimUploadUrlsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetClaimUploadUrlsQuery,
    GetClaimUploadUrlsQueryVariables
  > &
    (
      | { variables: GetClaimUploadUrlsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetClaimUploadUrlsQuery,
    GetClaimUploadUrlsQueryVariables
  >(GetClaimUploadUrlsDocument, options);
}
export function useGetClaimUploadUrlsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetClaimUploadUrlsQuery,
    GetClaimUploadUrlsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetClaimUploadUrlsQuery,
    GetClaimUploadUrlsQueryVariables
  >(GetClaimUploadUrlsDocument, options);
}
export function useGetClaimUploadUrlsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetClaimUploadUrlsQuery,
    GetClaimUploadUrlsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetClaimUploadUrlsQuery,
    GetClaimUploadUrlsQueryVariables
  >(GetClaimUploadUrlsDocument, options);
}
export type GetClaimUploadUrlsQueryHookResult = ReturnType<
  typeof useGetClaimUploadUrlsQuery
>;
export type GetClaimUploadUrlsLazyQueryHookResult = ReturnType<
  typeof useGetClaimUploadUrlsLazyQuery
>;
export type GetClaimUploadUrlsSuspenseQueryHookResult = ReturnType<
  typeof useGetClaimUploadUrlsSuspenseQuery
>;
export type GetClaimUploadUrlsQueryResult = Apollo.QueryResult<
  GetClaimUploadUrlsQuery,
  GetClaimUploadUrlsQueryVariables
>;
